export default __webpack_public_path__ + "static/videoBanner-28d974ee2dde53d01758a6b0755503f3.mp4";